var _moment = require('moment');

Vue.component('yearly-statistics', {

    data: function() {
        return {
            loading: false,
            currentYear: this.year,
            yearlyStatistics: [],
        }
    },
    props: {
        'year': { type: Number },
        'employee': { type: Object },
        'trans': { type: Object },
    },
    created(){
        this.loadData();
    },
    methods: {
        chooseYear(year) {
            this.currentYear = year;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            var _this = this;

            axios.get('show/yearly-statistics/' + this.currentYear, this.employee).then(response => {
                if(response && response.data)
                {
                    this.yearlyStatistics = response.data;
                    _this.loading = false;
                }
            }, function (error) {
                _this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                _this.loading = false;
            });
        },
        getMonthLabel(month) {
            return this.trans[month]+" "+this.currentYear;
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/YearlyStatistics.js